import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { ValidationService } from '../../shared/services/validation.service';
import { tap } from 'rxjs/operators';
import { HomeAction, HomeStateModel, UserDetail } from './home.actions';
import { StateClear } from 'ngxs-reset-plugin';
import { SubjectService } from '../../shared/services/subject/subject.service';
import { environment } from '../../../environments/environment';
import { NetmeraService } from "../../shared/services/netmera-service";
import { Open } from "../../model/netmera-events/open";

@State<HomeStateModel>({
  name: 'home',
  defaults: {
    userDetails: null
  },
})
@Injectable()
export class HomeState {

  constructor(
    private router: Router,
    private store: Store,
    private validationService: ValidationService,
    private subjectService: SubjectService,
    private netmeraService: NetmeraService,
    private open: Open
  ) {
  }

  @Selector()
  static userDetail(state: HomeStateModel) {
    return state.userDetails;
  }


  @Action(HomeAction)
  login(ctx: StateContext<HomeStateModel>, action: HomeAction) {
    return this.validationService.checkTrackingId(action.id).pipe(tap(userDto => {
      this.netmeraService.pushEvent(this.open.setEventObject(userDto?.requestHeader?.merchant?.merchantCode));
      this.subjectService.validate(userDto);
      ctx.patchState({
        userDetails: userDto
      });
      this.router.navigate(['/route', action.id]);

    }, error => {
      this.router.navigate(['/result/error', action.id]);
    }));
  }

  @Action(UserDetail)
  userDetail(ctx: StateContext<HomeStateModel>, action: UserDetail) {
    return ctx.patchState({
      userDetails: action.payload,
    });
  }

}
